/** Consent purpose — mirrors the backend ConsentPurpose enum (PascalCase on the wire). */
export enum ConsentPurpose {
  TermsOfService = "TermsOfService",
  PrivacyPolicy = "PrivacyPolicy",
  MarketingEmail = "MarketingEmail",
}
